<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <h2 class="card-title-desc">All Products</h2>
        <TableLoading v-if="products.page === 0"/>
        <div v-else class="px-4 pb-4">
          <data-table :columns="columns" :rows="products.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
            <template v-slot:productOrderAvailability="slotProps">
              <span class="badge rounded-pill font-size-11 badge-soft-success mx-1" v-if="slotProps.row.availableForOrder"> Yes </span>
              <span class="badge rounded-pill font-size-11 badge-soft-danger mx-1" v-else> No </span>
            </template>
            <template v-slot:actions="slotProps">
              <div class="button-items">
                <b-button v-if="checkForPermission(view_single_product_permission)" variant="info" size="sm" class="py-1 text-white" @click="viewProduct(slotProps.row.publicId)">
                  View Details
                </b-button>
                <b-button v-if="checkForPermission(edit_product_permission)" v-b-modal.edit-product variant="success" size="sm" class="py-1 text-white" @click="selectProduct(slotProps.row)">
                  Edit Product
                </b-button>
              </div>
            </template>
          </data-table>
          <b-pagination
              v-model="currentPage"
              :total-rows="products.total"
              :per-page="perPage"
              size="lg"
              align="center"
              class="mt-3"
          />
        </div>
      </div>
    </div>
    <b-modal
        id="edit-product"
        centered
        hide-footer
        hide-header
        size="xl"
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Product</h3>
        <product-form-component :selected_product="selected_product" :selected_unit="selectedUnit" button_text="Edit Product" @productAction="updateProduct"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-product')">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import ProductFormComponent from "@/components/products/product-form-component";
import DataTable from "@/components/data-table";
import {ALL_PRODUCTS, ALL_PRODUCTS_ORDER_UNITS} from "@/gql/stock";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import moment from 'moment'
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Products",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, ProductFormComponent, PageHeader, Layout},
  name: "products",
  data() {
    return {
      title: "Products",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Products",
          active: true
        }
      ],
      edit_product_permission: permissions.edit_product_permission,
      view_single_product_permission: permissions.view_single_product_permission,
      products: {
        page: 0,
        objects: []
      },
      selectedUnit: '',
      productOrderUnits: [],
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      selected_product: {},
      columns: [
        {
          field: 'productName',
          label: 'Product Name'
        },
        {
          field: 'code',
          label: 'Product Code'
        },
        {
          field: 'itfcode',
          label: 'ITF Code'
        },
        {
          field: 'jancode',
          label: 'JAN Code'
        },
        {
          field: 'productOrderAvailability',
          label: 'Available for Order?'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  apollo: {
    products: {
      query: ALL_PRODUCTS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    },
    productOrderUnits: {
      query: ALL_PRODUCTS_ORDER_UNITS
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      updateProductFn: 'stock/updateProduct',
    }),
    async updateProduct(data){
      await this.updateProductFn(data).then(resp => {
        if(resp.publicId){
          successToast(`Product ${resp.productName} updated successfully`)
        }
      })
    },
    viewProduct(public_id){
      this.$router.push(routeItems.single_product_route+'/'+public_id)
    },
    selectProduct(row){
      const pricing = row.pricing
      let selected;
      let selectedUnit;

      const units = this.productOrderUnits.find((unit) => unit.id === row.minimumOrderUnit)

      this.selected_product = {
        ...row,
        id: row.publicId,
        minimumOrderUnit: units,
        launchDate: moment(row.launchedDate).format('YYYY-MM-DD')
      }

      for (const key in pricing) {
        if(Object.keys(pricing[key]).length > 0){
          const unit = Object.keys(pricing[key])
          selected = unit[0]
        }
      }
      selectedUnit = this.productOrderUnits.find((unit) => unit.id === selected)

      this.selectedUnit = selectedUnit
    },
    searchFn(data){
      this.searchKeyword = data
    },
  }
}
</script>

<style scoped>

</style>
